var symphony = symphony || {};

;
(function () {

    symphony.submitForm = function (formId, formTitle, sendTo) {
        var $form = $('form#' + formId).eq(0);

        if ($form.length > 0) {
            
            document.body.classList.add('loading');

            // remove error messages
            $form.find('.form-error').remove();

            var fields = $form.serializeArray();
            var recaptchaResponse = $.grep(fields, function (f) {
                return f.name == 'g-recaptcha-response';
            })[0];
            if (typeof recaptchaResponse != "undefined") {
                recaptchaResponse = recaptchaResponse.value;
            }
            fields = $.grep(fields, function (f) {
                return f.name != 'g-recaptcha-response';
            });

            if (recaptchaResponse != null && recaptchaResponse.length == 0) {
                document.body.classList.remove('loading');
                $form.find('input[type="submit"]').before("<div id='form-message' class='u-cards form-error u-clear no-margin' style='padding: 30px 0 0!important'>\
                    <div class='u-card no-padding'>\
                        <div class='u-card-content u-sa-redBg u-textWhite u-textCenter'>\
                            Sorry, you must complete the captcha (I'm not a robot). If this is a mistake, please try again or contact support.\
                        </div>\
                    </div>\
                </div>");
                return;
            }

            $.post('/' + siteUrlAlias + '/symphonyform/submit?random=' + Date.now(), {
                formTitle: formTitle,
                sendTo: sendTo,
                fieldsStr: JSON.stringify(fields),
                recaptchaSecretKey: recaptchaSecretKey,
                recaptchaResponse: recaptchaResponse
            }, function (d) {
                document.body.classList.remove('loading');
                var response = JSON.parse(d);
                if (response.success) {
                    $form.html("<div id='form-message' class='u-cards'>\
                            <div class='u-card'>\
                                <div class='u-card-content u-sa-greyLightBg u-textCenter'>\
                                    Thanks for reaching out! We'll get back to you soon.\
                                </div>\
                            </div>\
                        </div>");
                    symphony.site.animateScrollTo($form, -60);
                } else {
                    $form.find('input[type="submit"]').before("<div id='form-message' class='u-cards form-error u-clear no-margin' style='padding: 30px 0 0!important'>\
                            <div class='u-card no-padding'>\
                                <div class='u-card-content u-sa-redBg u-textWhite u-textCenter'>\
                                    Oops! An error has occurred. Please try again or contact support.<br /><br />\
                                    Error message: " + response.message + "\
                                </div>\
                            </div>\
                        </div>");
                }
            })
                .fail(function () {
                    document.body.classList.remove('loading');
                    $form.find('input[type="submit"]').before("<div id='form-message' class='u-cards form-error u-clear no-margin' style='padding: 30px 0 0!important'>\
                        <div class='u-card no-padding'>\
                            <div class='u-card-content u-sa-redBg u-textWhite u-textCenter'>\
                                Oops! An error has occurred. Please try again or contact support.\
                            </div>\
                        </div>\
                    </div>");
                });

        }

    };

})();
